export default __webpack_public_path__ + "static/media/emailSent.fbec834b.svg";